var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5289 6.66428C14.8332 8.15794 14.6163 9.71081 13.9143 11.0639C13.2123 12.417 12.0677 13.4886 10.6713 14.0998C9.27485 14.7111 7.71106 14.8252 6.2407 14.4231C4.77034 14.021 3.48228 13.1269 2.59132 11.89C1.70036 10.6532 1.26035 9.14822 1.34468 7.62619C1.42902 6.10417 2.03258 4.65705 3.05473 3.52617C4.07689 2.39529 5.45583 1.64901 6.96162 1.41178C8.46741 1.17454 10.009 1.4607 11.3294 2.22252",
    stroke: "#00A63E",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 7.33054L7.99734 9.32983L14.6616 2.66553",
    stroke: "#00A63E",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.65861a6296936649d3c15f2ed4c33750.svg";
export { ForwardRef as ReactComponent };